import { PageRef } from 'providers/page-ref';

export type SettingsPageParams = {
  autoFocusElementId?: string; // if set, this will be used to scroll to the element with that id
};

export const ISettingsPage: PageRef<SettingsPageParams, void> = {
  pageName: 'SettingsPage',
} as PageRef<SettingsPageParams, void>;
